import { Box, Flex, Grid, Heading, Text } from '@chakra-ui/react'
import { Section } from '@/components/layout'
import { SectionLabel } from '@/components/typography'
import { useLocale } from '@/i18n'
import { LADDER_COPY } from './ladder.data'

export const HowWeWork = () => {
  const { locale } = useLocale()
  const ladder = LADDER_COPY[locale]

  return (
    <Section id="process">
      <SectionLabel mb="32px">{ladder.sectionLabel}</SectionLabel>
      <Text mb="56px" fontSize="17px" lineHeight="1.62" maxW="88ch">
        {ladder.engagementStatement}
      </Text>
      <Flex direction="column" gap="56px">
        {ladder.tracks.map((track) => (
          <Box key={track.intro}>
            <Text mb="24px" fontSize="15px" letterSpacing="0.02em" maxW="88ch" color="muted">
              {track.intro}
            </Text>
            <Grid
              templateColumns={{
                base: 'minmax(0, 1fr)',
                lg: `repeat(${String(track.steps.length)}, minmax(0, 1fr))`,
              }}
              borderTop={{ base: 'none', lg: '2px solid' }}
              borderColor="divider"
            >
              {track.steps.map((step, index) => (
                <Box
                  key={step.step}
                  pt={{ base: '20px', lg: '24px' }}
                  pr={{ base: 0, lg: '24px' }}
                  pb={{ base: '24px', lg: '28px' }}
                  borderTop={{ base: '2px solid', lg: 'none' }}
                  borderRight={{
                    base: 'none',
                    lg: index < track.steps.length - 1 ? '2px solid' : 'none',
                  }}
                  borderColor="divider"
                >
                  <Text
                    fontFamily="heading"
                    fontWeight="800"
                    fontSize="40px"
                    letterSpacing="-0.03em"
                    lineHeight="1"
                    color="accent"
                  >
                    {step.step}
                  </Text>
                  <Heading as="h4" mt="16px" fontSize="20px" fontWeight="800" letterSpacing="-0.015em">
                    {step.name}
                  </Heading>
                  <Text
                    mt="6px"
                    fontSize="11px"
                    letterSpacing="0.14em"
                    textTransform="uppercase"
                    color="muted"
                  >
                    {step.duration}
                  </Text>
                  <Text mt="14px" fontSize="15px" lineHeight="1.62">
                    {step.description}
                  </Text>
                </Box>
              ))}
            </Grid>
          </Box>
        ))}
      </Flex>
      <Text
        mt="48px"
        pt="20px"
        borderTop="2px solid"
        borderColor="divider"
        fontSize="15px"
        lineHeight="1.62"
        maxW="88ch"
        color="muted"
      >
        {ladder.footnote}
      </Text>
    </Section>
  )
}
